import Image from 'next/legacy/image';
import imgProxyLoader from 'helpers/imgProxyLoader';

export default function ProxyImage(props) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image loader={imgProxyLoader} {...props} />;
}
